/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-28, 12:54:06
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import sNumberValidation from '@/services/sNumberValidation';
import sDate from '@/services/sDate';
import { mapActions } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'BillingSearchTerms',

  components: { Card },

  props: ['billingList', 'isLoadingData'],

  data() {
    return {
      searchCategory: 'currentPeriod',
      dateMonth: new Date(),
      daysAmount: 30,
      sortBy: 'date',
      sort: 'desc',
      phoneNumber: null,
    };
  },

  computed: {
    dateYesterdayFormatted() {
      return sDate.formatDate(sDate.getYesterdayDate());
    },
    dateCurrentMonthStart() {
      return sDate.getDateByDay('firstDay', 'currentMonth');
    },
    dateLastMonthStart() {
      return sDate.getDateByDay('firstDay', 'lastMonth');
    },
    dateLastMonthEnd() {
      return sDate.getDateByDay('firstDay - 1', 'currentMonth');
    },
    disabledEndDates() {
      return { from: sDate.getYesterdayDate() };
    },
  },

  watch: {
    searchCategory(newValue) {
      // ustawienie defaultowej daty początkowej i końcowej po wybraniu opcji zakresu dat
      if (newValue === 'dateFromTo') {
        this.dateStart = sDate.getYesterdayDate();
        this.dateEnd = sDate.getYesterdayDate();
      }
    },
  },

  methods: {
    ...mapActions(['setBillingTerms', 'getBillingList']),
    
    notNewerThanYesterday(date) {
      let dateFormatted = sDate.formatDate(date);
      return (dateFormatted < this.dateYesterdayFormatted) ? dateFormatted : this.dateYesterdayFormatted;
    },
    dateStartFormatted() {
      if (!this.dateMonth) return null;
      let d = new Date(this.dateMonth.getFullYear(), this.dateMonth.getMonth(), 1);
      return this.notNewerThanYesterday(d);
    },
    dateEndFormatted() {
      if (!this.dateMonth) return null;
      let d = new Date(this.dateMonth.getFullYear(), this.dateMonth.getMonth()+1, 0);
      return this.notNewerThanYesterday(d);
    },
    /**
    * Metoda sprawdza czy podana przez użytkownika ilość dni nie przekracza maksymalnej ilości dni,
    * a także nie pozwala mu wpisać więcej cyfr niż ich ilość w maksymalnej ilości dni.
    *
    * @method validateDaysAmount()
    * @param brak
    * @return brak
    * @access public
    */
    validateDaysAmount() {
      const maxCharacters = 2;
      const maxDaysAmount = 60;
      const number = sNumberValidation.validateNumber(this.daysAmount, maxCharacters);
      this.daysAmount = number > maxDaysAmount ? maxDaysAmount : number;
    },

    /**
    * Metoda przekazujące odpowiednie dane do store ze względu na aktualnie zaznaczoną opcję
    * w formularzu (radio-button).
    *
    * @method submitSearchTerms()
    * @param brak
    * @return brak
    * @access public
    */
    submitSearchTerms() {
      this.$validator.validateAll();
      if (!this.errors.any()) {
        let terms = {
          page: 1,
          sort: this.sort,
          sortBy: this.sortBy,
          phoneNumber: this.phoneNumber,
        };
        switch (this.searchCategory) {
          case 'previousPeriod':
            terms = {
              ...terms,
              dateStart: this.dateLastMonthStart,
              dateEnd: this.dateLastMonthEnd,
            };
            break;
          case 'selectedMonth':
            terms = {
              ...terms,
              dateStart: this.dateStartFormatted(),
              dateEnd: this.dateEndFormatted(),
            };
            break;
          default:
            terms = {
              ...terms,
              dateStart: this.dateCurrentMonthStart,
              dateEnd: this.dateYesterdayFormatted,
            };
            break;
        }
        this.setBillingTerms(terms)
          .then(this.getBillingList);
      }
    },

    validatePhoneNumber() {
      const number = sNumberValidation.validateNumber(this.phoneNumber);
      this.phoneNumber = number;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Billing/BillingSearchTerms/component.js